import React from "react";
import { OverlayTrigger, Tooltip, Image } from "react-bootstrap";
import { isTablet } from "react-device-detect";
import PRODUCT_ICONS from "../../constants/product-icons";

export default function AttributeStack(props) {
  const { dietician_choice, luxury_grade, popular_choice, isMobile } = props;
  function attributeToolTip(toolTipText) {
    return (
      <OverlayTrigger
        key={toolTipText}
        placement="bottom"
        overlay={
          <Tooltip style={{ width: "10rem" }}>
            <strong>{toolTipText}</strong>.
          </Tooltip>
        }
      >
        <Image
          src={PRODUCT_ICONS[toolTipText]}
          className="attribute-icon ml-1"
          style={{
            width: isTablet ? "3vw" : isMobile ? "5.75vw" : "1.25vw",
            height: isTablet ? "3vw" : isMobile ? "5.75vw" : "1.25vw",
          }}
        />
      </OverlayTrigger>
    );
  }
  return (
    <div className="ml-1">
      {dietician_choice ? attributeToolTip("Dietician Choice") : null}
      {luxury_grade ? attributeToolTip("Luxury Grade") : null}
      {popular_choice ? attributeToolTip("Popular Choice") : null}
    </div>
  );
}
